export default __webpack_public_path__ + "static/media/RS-Lead-Eligbility-Page-Tutoial.2508cc9f.mp4";